import React from "react";
import { ASSETS } from "@/lib/brand";
import { useApp } from "@/context/AppContext";

export function CeoSection() {
  const { t } = useApp();
  return (
    <section className="py-20 px-6" data-testid="ceo-section">
      <div className="max-w-3xl mx-auto">
        <div className="gold-hairline mb-14" />
        <div className="grid sm:grid-cols-[minmax(0,220px)_1fr] gap-10 items-center">
          <div className="relative mx-auto sm:mx-0">
            <div className="absolute -inset-2 rounded-2xl" style={{ background: "linear-gradient(135deg, rgba(212,175,55,0.35), transparent)" }} />
            <img
              src={ASSETS.ceoPortrait}
              alt="Andrea T Freestone, International CEO"
              width="1536"
              height="1536"
              loading="lazy"
              data-testid="ceo-portrait"
              className="relative w-56 sm:w-full aspect-square object-cover rounded-2xl gold-border"
              style={{ boxShadow: "0 20px 50px -20px rgba(0,0,0,0.9)" }}
            />
          </div>
          <div className="text-center sm:text-left">
            <div className="text-xl sm:text-3xl font-serif-cu gold-text" style={{ letterSpacing: "0.42em", textTransform: "uppercase" }}>
              International
            </div>
            <div className="text-xl sm:text-3xl font-serif-cu gold-text mt-1" style={{ letterSpacing: "0.42em", textTransform: "uppercase" }}>
              CEO
            </div>
            <div className="text-base sm:text-lg font-serif-cu text-[color:var(--cu-ivory,#F4F1EA)] mt-4" style={{ letterSpacing: "0.12em" }} data-testid="ceo-name">
              Andrea T Freestone
            </div>
            <p className="text-[color:var(--cu-muted)] text-sm sm:text-base leading-relaxed mt-6 font-serif-cu italic">
              “{t("ceo_statement")}”
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
